module.exports = __webpack_public_path__ + "static/img/improvement_2.b6fd62e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/improvement_2.png
// module id = Tx8v
// module chunks = 1